import api from './api';
import { ComissaoCorretora, UpdateComissaoCorretoraDTO } from '../types/comissaoCorretora';

export const comissaoCorretoraService = {
  async listarPorApolice(apoliceId: number): Promise<ComissaoCorretora[]> {
    const response = await api.get(`/apolices/${apoliceId}/comissoes-corretora`);
    return response.data;
  },

  async atualizar(id: number, data: UpdateComissaoCorretoraDTO): Promise<ComissaoCorretora> {
    const response = await api.put(`/comissoes-corretora/${id}`, data);
    return response.data;
  },

  async excluir(id: number): Promise<void> {
    await api.delete(`/comissoes-corretora/${id}`);
  }
}; 